import { FC } from 'react';

import { BecomePartnerIcon } from '../../assets/icons/index';
import { AppFormattedMessage } from '../../components/app-formatted-message/index';

export type BecomePartnerEmptyStateProps = {};

export const BecomePartnerEmptyState: FC<BecomePartnerEmptyStateProps> = () => {
  return (
    <div className="relative flex h-fit shrink-0 -translate-y-1/2 flex-col items-center">
      <BecomePartnerIcon />
      <div className="absolute bottom-0 flex w-[282px] translate-y-[40%] flex-col items-center gap-3">
        <div className="relative flex h-8 w-[153px] overflow-hidden rounded-lg border border-[#548CE4] text-center text-label-xs font-bold uppercase">
          <div className="absolute inset-y-0 right-0 w-[56%] bg-white [clip-path:polygon(0_0,100%_0,100%_100%,15%_100%)]">
            <div className="centered flex h-full w-full text-[#5193E2]">
              <AppFormattedMessage id="PERKS_PROGRAM" />
            </div>
          </div>
          <div
            className="centered flex h-full w-full justify-start pl-4 text-white"
            style={{ background: 'linear-gradient(281.56deg, #3EBDDA 6.56%, #548CE4 96.08%)' }}
          >
            <AppFormattedMessage id="PERKS_PARTNER" />
          </div>
        </div>
        <span className="w-fit rounded-full bg-[#344054] px-2 text-[8px] font-semibold leading-[18px] text-white">
          <AppFormattedMessage id="PERKS_COMING_SOON" />
        </span>

        <span className="mt-3 text-center text-label-md font-medium text-gray-500">
          <AppFormattedMessage id="PERKS_EMPTY_DESCRIPTION" />
        </span>
        <a
          className="mt-3 w-full rounded bg-brand-700 py-3 text-center font-inter text-sm font-[550] text-white"
          href={process.env.REACT_APP_LANDING_URL + '/become-a-partner'}
        >
          <AppFormattedMessage id="PERKS_BECOME_PARTNER" />
        </a>
      </div>
    </div>
  );
};
